/**
 * Determines if exit intent modal should be shown based on ab_exit_modal_design_lab experiment
 * Variant 1 (candidate) shows the modal on exit intent and inactivity
 * Variant 0 (control) disables the modal entirely
 * @param experimentValue - The experiment variant value (0-1)
 * @returns true if modal should be enabled, false if disabled
 */
export function shouldShowExitIntentModal(experimentValue: number | undefined): boolean {
  return experimentValue === 1;
}
